export const DISCUSSION_TYPE = {
    ONE_ON_ONE: 'OneOnOneDiscussionType',
    PRIVATE: 'PrivateGroupDiscussionType',
    PUBLIC: 'PublicGroupDiscussionType',
    RESOURCE: 'ResourceDiscussionType',
    STUDY: 'StudyGroupDiscussionType',
    AGENDA: 'AgendaItemDiscussionType',
    ALL: 'all'
};
